(function($){
  var savedOtSystem = {
    init: function(){
      savedOtSystem.initSavedOtSystem();
    },
    initSavedOtSystem: function() {
      if($('#refreshOtSaved').length)
        Cookies.set('ot_saved', $('#refreshOtSaved').attr('data-ots'));
      if ($('.ovmap-saved-ot').length){
        $('.ov-listing__empty').hide();
      }
      var ot_saved = Cookies.get('ot_saved');
      ot_saved = (ot_saved !== undefined)?ot_saved.split(','):[];

      for(var i = 0 ; i < ot_saved.length ; i++) {
        if(ot_saved[i] === "")
          ot_saved.splice(i, 1);
        $('.ot-fav-save[data-id="' + ot_saved[i] + '"]').attr('data-saved', 'yes');
      }
      if (!ot_saved.length){
        $('a.ot-fav-save').hide();
      }

      var refreshLink = function(ot_saved) {
        var $favorites_link = $('.favorites.menu-item');
        if(ot_saved.length > 0)
          $favorites_link.addClass('m--full');
        else
          $favorites_link.removeClass('m--full');
        $('.ot-fav-save .icon-badge').html((ot_saved.length > 0)?ot_saved.length:'');
      };
      refreshLink(ot_saved);

      $(document).on('click', '.ot-fav-save:not(.m--sticky)', function(e) {
        e.preventDefault();

        var id = $(this).data('id');
        // console.log('click', $(this).attr('data-saved'));
        if($(this).attr('data-saved') === 'yes') {
          $('.ot-fav-save[data-id="' + id + '"]').attr('data-saved', 'no');
          ot_saved.splice(ot_saved.indexOf(id.toString()),1);

          var $saved_ot_if_listing_saved_context = $('.ovmap-saved-ot .ot-'+id.toString());
          if($saved_ot_if_listing_saved_context.length) {
            $saved_ot_if_listing_saved_context.fadeOut(200, function() {
              $saved_ot_if_listing_saved_context.remove();
              $('.iso-grid').isotope('layout');
              if($('.ovmap-saved-ot .iso-item').length === 0) {
                $('a.ot-fav-save').hide();
                $('.ovmap-saved-ot .ov-listing__actions').fadeOut(100, function() {
                  $('.ovmap-saved-ot .ov-listing__empty').fadeIn(200);
                });
              }
            });
          }
        } else {
          $('.ot-fav-save[data-id="' + id + '"]').attr('data-saved', 'yes');
          ot_saved.push(id.toString());
        }

        refreshLink(ot_saved);

        Cookies.set('ot_saved', ot_saved.join(','), { path: '/' });
        $('a.ot-fav-save').show();
      });

      $(document).on('click', '.ot-after-fav-save', function(e) {
        e.preventDefault();

        var $real_fav_save = $(this).parent().find('.ot-fav-save');

        var id = $real_fav_save.data('id');

        if($real_fav_save.attr('data-saved') === 'yes') {
          $('.ot-fav-save[data-id="' + id + '"]').attr('data-saved', 'no');
          ot_saved.splice(ot_saved.indexOf(id.toString()),1);

          var $saved_ot_if_listing_saved_context = $('.ovmap-saved-ot .ot-'+id.toString());
          if($saved_ot_if_listing_saved_context.length) {
            $saved_ot_if_listing_saved_context.fadeOut(200, function() {
              $saved_ot_if_listing_saved_context.remove();
              $('.iso-grid').isotope('layout');
              if($('.ovmap-saved-ot .iso-item').length === 0) {
                $('a.ot-fav-save').hide();
                $('.ovmap-saved-ot .ov-listing__actions').fadeOut(100, function() {
                  $('.ovmap-saved-ot .ov-listing__empty').fadeIn(200);
                });
              }
            });
          }
        } else {
          $('.ot-fav-save[data-id="' + id + '"]').attr('data-saved', 'yes');
          ot_saved.push(id.toString());
        }

        refreshLink(ot_saved);

        Cookies.set('ot_saved', ot_saved.join(','), { path: '/' });
        $('a.ot-fav-save').show();
      });
    },

  };
  $(document).ready(savedOtSystem.init);
})(jQuery);
